import { oc } from '@orpc/contract';
import { routeSchema, updateRouteInputSchema } from '../schemas/routes.schemas.js';
export const updateRouteContract = oc
    .route({
    method: 'PATCH',
    path: '/routes/{id}',
    tags: ['Routes'],
    summary: 'Rename a route revision or edit its description',
    description: 'MANAGER only. Measured values (distance, elevation) can only change through a new version.',
})
    .input(updateRouteInputSchema)
    .output(routeSchema);
//# sourceMappingURL=update-route.contract.js.map